/* global d3 */
import util from './_utils';
import lang from './lang';

const copy_panel = d3.select('.graphic__right.health'),
	bar_container = copy_panel.select('.rp__content--chart');

let svg,
	gs;

let outerWidth = null,
	outerHeight = null,
	margin = null,
	width = null,
	height = null,
	yValues = null;

const barHeight = 30;

let healthData,
	xScale,
	yScale;

const xAccessor = 'Percent',
	yAccessor = 'Country',
	filterAccessor = 'Response';

let currentResponse = '';

let step = 0;

function resize() {}

function init() {
	return new Promise((resolve, reject) => {
		Promise.all([
			d3.csv('assets/data/health_section.csv'),
		]).then(function(files) {
			healthData = formatData(files[0]);
			setup();
			resolve();
		}).catch(function(err) {
			console.log(err);
		})
	})
}

function next(index) {
	step = index + 1;

	//if (currentIndex === 0) buildBars('');
	if (step === 0) buildBars('')
	if (step === 1) buildBars('Health Scare');
	if (step === 2) buildBars('Improve my Body Image');
	if (step === 3) buildBars('Get Stronger');
	if (step === 4) buildBars('Less Anxious and Depressed');
}

function formatData(rawData) {
	const data = rawData.map(d => {
		d[xAccessor] = +d[xAccessor];
		return d;
	})

	data.sort((a, b) => b[xAccessor] - a[xAccessor]);

	return data;
}

function setup(build = false) {
	outerWidth = bar_container.node().offsetWidth;

	bar_container.selectAll('*:not(.tooltip)').remove();

	svg = bar_container.append('svg')
		.attr('width', outerWidth)
		.attr('height', 0);

	yValues = [...new Set(healthData.map(d => d[yAccessor]))];

	margin = {
		left: getLeftMargin(),
		right: 10,
		top: 10,
		bottom: 10
	};

	if (build) buildBars(currentResponse);
}

function buildBars(response) {
	currentResponse = response;

	const responseData = healthData.filter(d => d[filterAccessor] === response);

	const responseYValues = responseData.map(d => d[yAccessor]);

	outerHeight = responseYValues.length * barHeight;
	yScale = d3.scaleBand().rangeRound([0, outerHeight]).domain(responseYValues).padding(0.1);

	const xMax = d3.max(responseData, d => d[xAccessor]);
	xScale = d3.scaleLinear().rangeRound([margin.left + 4, outerWidth - 4]).domain([0, xMax]).nice();

	svg.transition()
		.duration(yValues.length * 100)
		.attr('height', outerHeight);

	const gs = svg.selectAll('.bar')
		.data(responseData, d => d[yAccessor])

	const gsEnter = gs.enter()
		.append('g')
		.attr('class', 'bar')
		.attr('transform', d => `translate(0, ${yScale(d[yAccessor])})`)

	gsEnter.append('rect')
		.attr('x', xScale(0))
		.attr('y', yScale.bandwidth() / 2 - 1)
		.attr('width', 0)
		.attr('height', 2)
		.attr('fill', '#F86214')
		.transition(0)
		.delay((d, i) => i * 100)
		.duration(1000)
		.attr('width', d => xScale(d[xAccessor]) - xScale(0))

	gsEnter.append('circle')
		.attr('cx', xScale(0))
		.attr('cy', yScale.bandwidth() / 2)
		.attr('r', 4)
		.attr('fill', '#F86214')
		.transition(0)
		.delay((d, i) => i * 100)
		.duration(1000)
		.attr('cx', d => xScale(d[xAccessor]))

	const gsEnterText = gsEnter.append('text')
		.attr('text-anchor', 'end')
		.attr('x', margin.left)
		.attr('y', yScale.bandwidth() / 2)
		.attr('fill', (d, i) => i === 0 ? '#242428' : '#999999')
		.attr('dy', 4)
		.text(d => `${lang.translateViz('health', 'Country--' + d[yAccessor])} - `);

	gsEnterText.append('tspan')
		.attr('font-weight', (d, i) => i === 0 ? 600 : 200)
		.text(d => {
			const spacer = lang.getCurrentLang() == 'de-DE' || lang.getCurrentLang() == 'es-ES' ? ' ' : '';
			return `${Math.round(d[xAccessor] * 100)}${spacer}%`
		});

	gs.transition()
		// .delay(1000)
		.duration(1000)
		.attr('transform', d => `translate(0, ${yScale(d[yAccessor])})`);

	gs.select('rect')
		.transition()
		.duration(1000)
		.attr('width', d => xScale(d[xAccessor]) - xScale(0))

	gs.select('circle')
		.transition()
		.duration(1000)
		.attr('cx', d => xScale(d[xAccessor]))

	gs.select('text')
		.text(d => {
			const spacer = lang.getCurrentLang() == 'de-DE' || lang.getCurrentLang() == 'es-ES' ? ' ' : '';
			return `${lang.translateViz('health', 'Country--' + d[yAccessor])} - ${Math.round(d[xAccessor] * 100)}${spacer}%`
		})
		.transition()
		.duration(1000)
		.attr('fill', (d, i) => i === 0 ? '#242428' : '#999999')
		.attr('font-weight', (d, i) => i === 0 ? 600 : 200);

	const gsExit = gs.exit()
		.transition()
		.delay(yValues.length * 100)
		.duration(0)
		.remove();
}

function getLeftMargin(values) {
	const fakeTextWidths = [];

	const fakeTextValues = svg.selectAll('.fake-margin-text')
		.data(yValues)
		.enter()
		.append('text')
		.attr('x', -1000)
		.attr('y', -1000)
		.attr('visibility', 'hidden')
		.text(d => {
			const spacer = lang.getCurrentLang() == 'de-DE' || lang.getCurrentLang() == 'es-ES' ? ' ' : '';
			return `${lang.translateViz('health', 'Country--' + d)} - 100${spacer}%`
		})
		.each(function() {
			fakeTextWidths.push(d3.select(this).node().getComputedTextLength());
		});

	fakeTextValues.remove();

	return d3.max(fakeTextWidths);
}

export default {
	init,
	resize,
	next,
	setup,
	buildBars,
};